export function isDesktopAppDetected(): boolean {
  return navigator.userAgent.toString().indexOf('LiveChatSmartClient') !== -1;
}
